
export const SET_FEATHERS_API_CLIENT = '@@ks-feathers-client/SET_FEATHERS_API_CLIENT';
export const GET_FEATHERS_API_CLIENT = '@@ks-feathers-client/GET_FEATHERS_API_CLIENT';
export const CREATE_FEATHERS_API_CLIENT = '@@ks-feathers-client/CREATE_FEATHERS_API_CLIENT';

export const SET_FEATHERS_SERVER_CLIENT = '@@ks-feathers-client/SET_FEATHERS_SERVER_CLIENT';
export const GET_FEATHERS_SERVER_CLIENT = '@@ks-feathers-client/GET_FEATHERS_SERVER_CLIENT';
export const CREATE_FEATHERS_SERVER_CLIENT = '@@ks-feathers-client/CREATE_FEATHERS_SERVER_CLIENT';

export const SET_FEATHERS_PAYLOAD = '@@ks-feathers-client/SET_FEATHERS_PAYLOAD';
export const SET_DB_CONFIG = '@@ks-feathers-client/SET_DB_CONFIG';
export const SET_DB_URL = '@@ks-feathers-client/SET_DB_URL';
export const SET_API_HOST_URL = '@@ks-feathers-client/SET_API_HOST_URL';
export const SET_API_HOST_LEGACY_URL = '@@ks-feathers-client/SET_API_HOST_LEGACY_URL';
export const SET_API_ACCESS_TOKEN = '@@ks-feathers-client/SET_API_ACCESS_TOKEN';

export const Status = {
  DISCONNECTED: 0,
  RECONNECTING: 1,
  CONNECTED: 2
};
